import { CarouselV2 } from "@website/ui/carousel";
import { Skeleton } from "@website/ui/skeleton";
import styles from "@website/widget/banner-medium/banner-medium.module.scss";
import { BannerMediumItem } from "@website/widget/banner-medium/components";
import { BannerSlidePropertiesType } from "@website/widget/banner-slide/banner-slide.types";
import { FC, memo, useState } from "react";

const BannerSlide: FC<BannerSlidePropertiesType> = (properties) => {
  const {
    list,
    isLoading = false,
    className,
    width,
    height = 300,
    shouldRedirectUsingJs
  } = properties;
  const [selectedTab, setSelectedTab] = useState<number>(0);

  return isLoading ? (
    <Skeleton height={height} />
  ) : list?.length > 0 ? (
    <CarouselV2
      itemClass={`${className} ${styles["item"]}`}
      keyCarousel={`BannerMedium-${list[selectedTab]?.bannerId}`}
      list={list.map((item, index) => (
        <BannerMediumItem
          shouldRedirectUsingJs={shouldRedirectUsingJs}
          key={index++}
          {...{
            ...item,
            id: index,
            height: height || item.height,
            width: width || item.width,
            onClick: () => setSelectedTab(index)
          }}
        />
      ))}
      mode="free"
      options={{
        slides: {
          perView: "auto",
          spacing: 16
        }
      }}
    />
  ) : null;
};

const BannerSlideMemoized = memo(BannerSlide);
export { BannerSlideMemoized as BannerSlide };
